import { FieldCheckboxGroup } from '../../../components';

import css from './MailchimpSubscribe.module.css';

/**
 * A component that renders the optional subscription to mailchimp list
 *
 * @component
 * @param {Object} props
 * @param {intlShape} props.intl - The intl object
 * @returns {JSX.Element}
 */
const MailchimpSubscribe = props => {
  const { intl } = props;

  return (
    <div className={css.root}>
      <FieldCheckboxGroup
        name="subscribe"
        id="signup-subscribe"
        optionLabelClassName={css.finePrint}
        options={[
          {
            key: 'mailchimp-subscribe',
            label: intl.formatMessage({ id: 'AuthenticationPage.mailingListLabel' }),
          },
        ]}
      />
    </div>
  );
};

export default MailchimpSubscribe;
